###
  PopupJS crud widget
###

class INTENT.widgets.PopupJS
  @ATTR_NAME: "data-widget-popup"

  @ATTR_ACCEPT_TERMS: 'data-accept-terms'
  @ATTR_MODAL_HANDLER: 'data-modal-handler'

  @ATTR_LOCATION: "#{@ATTR_NAME}-location"
  @ATTR_HEIGHT: "#{@ATTR_NAME}-height"
  @ATTR_WIDTH: "#{@ATTR_NAME}-width"

  constructor: (@el) ->
    @s = @.constructor

    modal_handler = @el.attr @s.ATTR_NAME
    @bs_modal = $ "[#{@s.ATTR_MODAL_HANDLER}='#{modal_handler}']"

    @el.on "click", @show_popup

    if @bs_modal.length > 0
      @bs_modal.find("[#{@s.ATTR_ACCEPT_TERMS}]").on 'click', (e) =>
        self = $ e.target
        element = $ self.attr(@s.ATTR_ACCEPT_TERMS)
        element.prop 'checked', true
        @bs_modal.modal 'hide'

  get_settings: =>
    width = @get_width()
    height = @get_height()
    left = (screen.width  - width) / 2
    top = (screen.height - height) / 2

    "width=#{width}, height=#{height}, top=#{top}, left=#{left}"

  get_height: () =>
    h = @el.attr @s.ATTR_HEIGHT
    h || 550

  get_width: () =>
    w = @el.attr @s.ATTR_WIDTH
    w || 900

  get_location: () =>
    l = @el.attr @s.ATTR_LOCATION
    l || @el.attr 'href'

  show_popup: () =>
    if @bs_modal.length > 0
      @bs_modal.find('.modal-body').load @get_location(), =>
        @bs_modal.modal()

      return false

    popup = window.open @get_location(), 'GetIntnet', @get_settings()

    if window.focus then popup.focus()

    return false